<template>
	<div class="process">
		<div class="process__featured__text"><h3>Design Process</h3></div>

		<div class="process__grid">
			<ServicesSideNav class="process__nav" />
			<div class="process__items" v-scroll-spy="{ offset: 350 }">
				<div class="process__research">
					<div class="process__research--title">
						<div class="process__icon">
							<!-- <img src="../assets/images/icons/svg/research.svg" alt="research" /> -->
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
								<g id="research" data-name="researchLayer 2">
									<g id="researchLayer_3" data-name="researchLayer 3">
										<path
											class="research-cls-1"
											d="M14.67,9.5a.6.6,0,0,1-.6-.6,5.18,5.18,0,0,0-.66-2.52.6.6,0,0,1,1.05-.59,6.38,6.38,0,0,1,.81,3.11A.6.6,0,0,1,14.67,9.5Z"
										/>
										<path
											class="research-cls-1"
											d="M5.37,4.94a.6.6,0,0,1-.47-.23A.6.6,0,0,1,5,3.87a6.38,6.38,0,0,1,7.31-.34.6.6,0,0,1,.18.83.59.59,0,0,1-.82.18,5.15,5.15,0,0,0-5.94.28A.63.63,0,0,1,5.37,4.94Z"
										/>
										<path
											class="research-cls-1"
											d="M19.82,19,15.6,14.76a8.93,8.93,0,1,0-.84.84L19,19.82a.59.59,0,0,0,.42.18.56.56,0,0,0,.42-.18A.58.58,0,0,0,19.82,19ZM1.2,8.9a7.71,7.71,0,1,1,13.16,5.44h0A7.7,7.7,0,0,1,1.2,8.9Z"
										/>
									</g>
								</g>
							</svg>
						</div>
						<div class="process__titletext"><h1>Research</h1></div>
					</div>
					<div class="process__research--body">
						<p>
							Our design team and business analyst conduct a kick-off meeting
							and other activities to find existing problems and solutions in
							your particular niche or industry, define your product’s unique
							value proposition, and learn about your customer segments.
						</p>
					</div>
				</div>
				<div class="process__design">
					<div class="process__design--title">
						<div class="process__icon">
							<!-- <img src="../assets/images/icons/svg/design.svg" alt="design" /> -->
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
								<g id="designLayer_2" data-name="designLayer 2">
									<g id="designLayer_3" data-name="designLayer 3">
										<path
											class="design-cls-1"
											d="M10.48,7.11h2.41V9.52h.95V6.63a.47.47,0,0,0-.47-.47H10.48Z"
										/>
										<path
											class="design-cls-1"
											d="M7.11,10.48h-1v2.89a.47.47,0,0,0,.47.47H9.52v-.95H7.11Z"
										/>
										<path
											class="design-cls-1"
											d="M19.52,0H6.63a.47.47,0,0,0-.47.48V6.16H.48A.47.47,0,0,0,0,6.63V19.52A.47.47,0,0,0,.48,20H13.37a.47.47,0,0,0,.47-.48V13.84h5.68a.47.47,0,0,0,.48-.47V.48A.47.47,0,0,0,19.52,0Zm-.47,12.89H13.84V10.48h-.95v2.41H10.48v.95h2.41v5.21H1V7.11H6.16V9.52h1V7.11H9.52v-1H7.11V1H19.05Z"
										/>
									</g>
								</g>
							</svg>
						</div>
						<div class="process__titletext"><h1>Design</h1></div>
					</div>
					<div class="process__design--body">
						<p>
							User interface (UI) design is about creating visual components of
							a website. Solid UI design is not only about visual appeal; it
							also has a great impact on user acquisition and retention. Our UI
							design solutions establish your brand identity, making your
							product stand out.
						</p>
					</div>
				</div>
				<div class="process__prototyping">
					<div class="process__prototyping--title">
						<div class="process__icon">
							<!-- <img
								src="../assets/images/icons/svg/prototype.svg"
								alt="prototype"
							/> -->
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 13.6">
								<g id="protoLayer_2" data-name="protoLayer 2">
									<g id="protoLayer_3" data-name="protoLayer 3">
										<path
											class="proto-cls-1"
											d="M5.24,12a.49.49,0,0,1-.34-.14L.14,7.14a.46.46,0,0,1,0-.67L4.9,1.7a.48.48,0,0,1,.67,0,.48.48,0,0,1,0,.68L1.15,6.8l4.42,4.43a.46.46,0,0,1,0,.67A.47.47,0,0,1,5.24,12Z"
										/>
										<path
											class="proto-cls-1"
											d="M14.76,12a.47.47,0,0,1-.33-.14.46.46,0,0,1,0-.67L18.85,6.8,14.43,2.38a.48.48,0,0,1,0-.68.48.48,0,0,1,.67,0l4.76,4.77a.46.46,0,0,1,0,.67L15.1,11.9A.49.49,0,0,1,14.76,12Z"
										/>
										<path
											class="proto-cls-1"
											d="M7.69,13.6a.41.41,0,0,1-.16,0A.48.48,0,0,1,7.24,13L11.86.31A.48.48,0,0,1,12.47,0a.48.48,0,0,1,.29.61L8.14,13.29A.49.49,0,0,1,7.69,13.6Z"
										/>
									</g>
								</g>
							</svg>
						</div>
						<div class="process__titletext"><h1>Prototyping</h1></div>
					</div>
					<div class="process__prototyping--body">
						<p>
							Designers are ready to generate ideas and turn them into
							prototypes. Based on our research findings, we generate as many
							design ideas as possible to decide on the best one.
						</p>
					</div>
				</div>
				<div class="process__testing">
					<div class="process__testing--title">
						<div class="process__icon">
							<!-- <img src="../assets/images/icons/svg/testing.svg" alt="testing" /> -->
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18.24">
								<g id="testingLayer_2" data-name="testingLayer 2">
									<g id="testingLayer_3" data-name="testingLayer 3">
										<path
											class="testing-cls-1"
											d="M2.05,4.33.16,2.43a.54.54,0,1,1,.76-.76L2.05,2.8,4.69.16a.55.55,0,0,1,.77,0,.54.54,0,0,1,0,.76Z"
										/>
										<circle class="cls-1" cx="2.05" cy="8.95" r="1.58" />
										<circle class="cls-1" cx="2.05" cy="16.58" r="1.58" />
										<path
											class="testing-cls-1"
											d="M17.23,1.47H9.14A.54.54,0,0,1,8.6.93.54.54,0,0,1,9.14.39h8.09a.54.54,0,0,1,.54.54A.54.54,0,0,1,17.23,1.47Z"
										/>
										<path
											class="testing-cls-1"
											d="M19.46,3.71H9.14a.54.54,0,1,1,0-1.08H19.46a.54.54,0,0,1,0,1.08Z"
										/>
										<path
											class="testing-cls-1"
											d="M17.23,8.38H9.14a.54.54,0,1,1,0-1.08h8.09a.54.54,0,0,1,0,1.08Z"
										/>
										<path
											class="testing-cls-1"
											d="M19.46,10.61H9.14a.54.54,0,1,1,0-1.08H19.46a.54.54,0,1,1,0,1.08Z"
										/>
										<path
											class="testing-cls-1"
											d="M17.23,16H9.14a.54.54,0,0,1-.54-.54.54.54,0,0,1,.54-.54h8.09a.54.54,0,0,1,.54.54A.54.54,0,0,1,17.23,16Z"
										/>
										<path
											class="testing-cls-1"
											d="M19.46,18.24H9.14a.54.54,0,0,1,0-1.08H19.46a.54.54,0,0,1,0,1.08Z"
										/>
									</g>
								</g>
							</svg>
						</div>
						<div class="process__titletext"><h1>Testing</h1></div>
					</div>
					<div class="process__testing--body">
						<p>
							We pay maximum attention to various tests. When the whole design
							of the product is ready, that means it’s time to make sure the
							product works as intended and properly.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ServicesSideNav from "./ServicesSideNav.vue";
	export default {
		components: {
			ServicesSideNav,
		},
	};
</script>

<style lang="scss" scoped>
	@import "ServicesProcess.scss";
</style>
